// app/javascript/controllers/youtube_embed_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field"];

  connect() {
    this.editor = this.fieldTarget.editor;
    this.attachPasteHandler();
  }

  disconnect() {
    this.removePasteHandler();
  }

  attachPasteHandler() {
    this.handlePasteBound = this.handlePaste.bind(this);
    // Listen to native paste event on the trix-editor element
    const trixEditor = this.element.querySelector("trix-editor");
    if (trixEditor) {
      trixEditor.addEventListener("paste", this.handlePasteBound, true);
    }
  }

  removePasteHandler() {
    if (this.handlePasteBound) {
      const trixEditor = this.element.querySelector("trix-editor");
      if (trixEditor) {
        trixEditor.removeEventListener("paste", this.handlePasteBound, true);
      }
    }
  }

  // Detect YouTube URLs in pasted content
  handlePaste(event) {
    // Get text from clipboard
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text/plain");

    const match = pastedText.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/
    );

    if (match) {
      // Prevent the default paste behavior
      event.preventDefault();
      event.stopPropagation();

      const videoId = match[1];
      const url = `https://www.youtube.com/watch?v=${videoId}`;

      if (confirm(`Embed this YouTube video?\n\n${url}`)) {
        // Insert the embed
        this.insertYoutubeEmbed(videoId);
      } else {
        // User declined - insert as a link instead
        this.editor.insertHTML(
          `<a href="${url}" target="_blank" rel="noopener">${url}</a>`
        );
      }
    }
  }

  // Insert YouTube embed using SGID approach
  async insertYoutubeEmbed(videoId) {
    try {
      console.log("Fetching YouTube embed data for video ID:", videoId);

      // Fetch the SGID and content from the server
      const response = await fetch(`/youtube/${videoId}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Received embed data:", data);

      // Import Trix dynamically to access Trix.Attachment
      const Trix = (await import("trix")).default;

      // Create a Trix attachment with the SGID
      const attachment = new Trix.Attachment({
        sgid: data.sgid,
        content: data.content
      });

      // Insert the attachment into the editor
      this.editor.insertAttachment(attachment);
      console.log("YouTube embed attachment inserted successfully");

      // Add a line break for better UX
      this.editor.insertLineBreak();
    } catch (error) {
      console.error("Failed to insert YouTube embed:", error);
      alert("Failed to embed YouTube video. Please try again.");
    }
  }
}
